import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { IDirectorsService } from "services/DirectorsService";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

export const deleteDirector = createAsyncThunk("directors/DeleteDirector", async (directorID: string) => {
  const directorsService = container.get<IDirectorsService>(SERVICE_TYPES.DirectorsService);
  try {
    await directorsService.deleteDirector(directorID);
  } catch (error) {
    toast.error("Director failed to delete");
    throw error;
  }
  toast.success("Director successfully deleted");
});
